<template>
  <div class="printed">
    <v-card outlined style="overflow-y: auto;">
      <v-card-text>
        <v-row>
          <v-col cols="8" sm="4" md="8">
            <v-row class="ml-1">
              <v-col cols="4" sm="2" md="4" class="pa-0" style="align-self: center" v-if="urlLogo!=null">
                <v-img
                  style="-webkit-print-color-adjust: exact"
                  :src="urlLogo"
                  max-height="150"
                  max-width="150"
                  lazy-src="https://via.placeholder.com/150"
                >
                </v-img>
                <!-- <v-avatar v-if="urlLogo!=null" left size="120">
                  <img
                    :src="urlLogo"
                    alt="Logo"
                  >
                </v-avatar> -->
              </v-col>
              <v-col cols="8" sm="4" md="8" class="pa-0" style="align-self: center">
                <h3 class="font-weight-bold mt-1 mb-1">{{dataUser.company == undefined ? 'Tidak ada nama' : dataUser.company.name}}</h3>
                <p class="mb-0">Telepon: {{dataUser.company == undefined ? 'Tidak ada telepon' : dataUser.company.telp}}</p>
                <p class="mb-0">Email: {{dataUser.company == undefined ? 'Tidak ada email' : dataUser.company.email}}</p>
                <p class="mb-0">Alamat: {{dataUser.company == undefined ? 'Tidak ada alamat' : dataUser.company.address}}</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" sm="2" md="4" style="align-self: center; text-align: -webkit-right;-webkit-print-color-adjust: exact">
            <!-- <h3 class="font-weight-bold text-right ma-0">{{dataDetails.type == 'PEMASUKAN' ? 'Invoice' : 'Purchase Order'}}</h3> -->
            <!-- <h3 v-if="dataDetails.type == 'PEMASUKAN'" class="font-weight-bold text-right ma-0 green--text">Invoice</h3>
            <h3 v-else class="font-weight-bold text-right ma-0 red--text">Purchase Order</h3> -->
            <v-card
              elevation="0"
              height="40"
              :width="dataDetails.company_id != 18 ? 150 : 250"
              class="green"
              v-if="dataDetails.type == 'PEMASUKAN'"
            >
              <v-row
                v-if="dataDetails.company_id != 18"
                class="fill-height white--text h3 ma-0"
                align="center"
                justify="center"
                v-text="`Invoice`"
              ></v-row>
              <v-row
                v-else
                class="fill-height white--text h4 ma-0"
                align="center"
                justify="center"
                v-text="`Pengajuan Anggaran`"
              ></v-row>
            </v-card>
            <v-card
              v-else
              elevation="0"
              height="40"
              width="250"
              class="orange"
            >
              <v-row
                class="fill-height white--text h3 ma-0"
                align="center"
                justify="center"
                v-text="`Purchase Order`"
              ></v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="2" md="4" style="border-top: 1px solid;-webkit-print-color-adjust: exact">
            <p class="font-weight-bold ma-0">{{dataDetails.type == 'PEMASUKAN' ? 'Nama Customer' : 'Nama Vendor'}}:</p><p class="text-left ma-0">{{dataDetails.customer == null ? 'Tidak ada nama' : dataDetails.customer.name}}</p>
            <p class="font-weight-bold ma-0">{{dataDetails.type == 'PEMASUKAN' ? 'Telp Customer' : 'Telp Vendor'}}:</p><p class="text-left ma-0">{{dataDetails.customer == null ? 'Tidak ada telpon' : dataDetails.customer.telp}}</p>
            <p class="font-weight-bold ma-0">{{dataDetails.type == 'PEMASUKAN' ? 'Tanggal Invoice:' : 'Tanggal Purchase:'}}</p><p class="text-left ma-0">{{formatdate(dataDetails.date)}}</p>
            <!-- <p class="font-weight-bold ma-0">Nama {{dataDetails.type == 'PEMASUKAN' ? 'Pemasukan' : 'Pengeluaran'}}:</p><p class="text-left ma-0">{{dataDetails.name == null ? 'Tidak ada nama' : dataDetails.name}}</p>
            <p class="font-weight-bold ma-0">Catatan:</p><p class="text-left ma-0">{{dataDetails.note == null ? 'Tidak ada catatan' : dataDetails.note}}</p> -->
          </v-col>
          <v-col cols="4" sm="2" md="4" class="text-center" style="border-top: 1px solid;-webkit-print-color-adjust: exact">
            <!-- <p class="font-weight-bold ma-0">STATUS </p>
            <template v-if="dataDetails.status == 'COMPLETED'">
              <v-chip
                class="mb-2"
                color="green"
                label
                outlined
              >
                <v-icon left>check_box</v-icon>
                {{dataDetails.status}}
              </v-chip>
            </template> -->
          </v-col>
          <v-col cols="4" sm="2" md="4" style="border-top: 1px solid;-webkit-print-color-adjust: exact">
            <p class="font-weight-bold text-right ma-0">Nama Petugas</p><p class="text-right ma-0">{{dataUser.name}}</p>
            <p class="font-weight-bold text-right ma-0">{{dataDetails.type == 'PEMASUKAN' ? 'Invoice Number:' : 'Purchase Number:'}}</p><p class="text-right ma-0">{{dataDetails.id}}</p>
            <p class="font-weight-bold text-right ma-0">Jumlah Pesanan:</p><p class="text-right ma-0">{{dataDetails.items.length}}</p>
          </v-col>
        </v-row>
        <v-simple-table fixed-header max-height="300px" class="mb-4 mt-4">
          <template>
            <thead>
              <tr>
                <td style="background-color: lightgray!important;-webkit-print-color-adjust: exact" v-for="header in computedHeaders" :key="header.text" :class="header.align">{{ header.text }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="subItem in dataDetails.items" :key="subItem.id">
                <td class="text-left" v-if="subItem.schedule">
                    <b>{{ subItem.item_name }}</b> 
                    <br/> Mulai: {{ formatdate(subItem.schedule.start).substring(0, 16) }} 
                    <br/> Selesai: {{ formatdate(subItem.schedule.finish).substring(0, 16) }} 
                </td>
                <td class="text-left" v-else>{{ subItem.item_name }}</td>
                <td class="text-center" v-if="subItem.schedule">{{ Number(subItem.qty) % 1 == 0 ? Number(subItem.qty) : Number(subItem.qty).toFixed(2).replace(".00", "") }} Jam</td>
                <td class="text-center" v-else>{{ Number(subItem.qty) % 1 == 0 ? Number(subItem.qty) : Number(subItem.qty).toFixed(2).replace(".00", "") }} Pcs</td>
                <td class="text-center">{{ dataDetails.type == 'PEMASUKAN' ? convertCurrency(Math.round(Number(subItem.harga_jual))) : convertCurrency(Math.round(Number(subItem.harga_beli)))}}</td>
                <td class="text-center" v-if="dataDetails.company_id != 18"><span class="green--text">{{ Number(subItem.discount) }}%</span></td>
                <td class="text-center" v-if="dataDetails.company_id != 18"><span class="orange--text">{{ Number(subItem.ppn) }}%</span></td>
                <td class="text-right" v-if="subItem.discount!=0 && subItem.ppn!=0">{{ dataDetails.type == 'PEMASUKAN' ? convertCurrency(Math.round(( (subItem.qty*(Number(subItem.harga_jual))) * (1-(subItem.discount/100)) ) * (1+(subItem.ppn/100)))) : convertCurrency(Math.round(( (subItem.qty*(Number(subItem.harga_beli))) * (1-(subItem.discount/100)) ) * (1+(subItem.ppn/100)))) }}</td>
                <td class="text-right" v-else-if="subItem.discount!=0">{{ dataDetails.type == 'PEMASUKAN' ? convertCurrency(Math.round(( (subItem.qty*(Number(subItem.harga_jual))) * (1-(subItem.discount/100)) ))) : convertCurrency(Math.round(( (subItem.qty*(Number(subItem.harga_beli))) * (1-(subItem.discount/100)) )))}}</td>
                <td class="text-right" v-else-if="subItem.ppn!=0">{{ dataDetails.type == 'PEMASUKAN' ? convertCurrency(Math.round(( (subItem.qty*(Number(subItem.harga_jual))) * (1+(subItem.ppn/100)) ))) : convertCurrency(Math.round(( (subItem.qty*(Number(subItem.harga_beli))) * (1+(subItem.ppn/100)) )))}}</td>
                <td class="text-right" v-else>{{ dataDetails.type == 'PEMASUKAN' ? convertCurrency(Math.round(subItem.qty*(Number(subItem.harga_jual)))) : convertCurrency(Math.round(subItem.qty*(Number(subItem.harga_beli))))}}</td>
                <!-- <td class="text-right">{{dataDetails.type == 'PEMASUKAN' ? subItem.qty * (Number(subItem.harga_jual)) : subItem.qty * (Number(subItem.harga_beli))}}</td> -->
              </tr>
              <tr>
                <td style="border-top: 1px solid;-webkit-print-color-adjust: exact" :colspan="dataDetails.company_id == 18 ? '2':'4'"></td>
                <td style="border-top: 1px solid;-webkit-print-color-adjust: exact" v-if="paid > 0"><h6 class="text-right font-weight-bold">Subtotal:</h6></td>
                <td style="border-top: 1px solid;-webkit-print-color-adjust: exact" v-else><h6 class="text-right font-weight-bold">Total:</h6></td>
                <td style="border-top: 1px solid;-webkit-print-color-adjust: exact" class="text-right">{{ convertCurrency(Number(dataDetails.total)) }}</td>
              </tr>
              <tr v-if="paid > 0">
                <td style="background-color: lightgreen!important;-webkit-print-color-adjust: exact" :colspan="dataDetails.company_id == 18 ? '2':'4'"></td>
                <td style="background-color: lightgreen!important;-webkit-print-color-adjust: exact" class="text-right font-weight-bold">DIBAYAR:</td>
                <td style="background-color: lightgreen!important;-webkit-print-color-adjust: exact" class="text-right">{{ convertCurrency(paid) }}</td>
              </tr>
              <tr v-if="dataDetails.total - paid > 0 && paid > 0">
                <td :colspan="dataDetails.company_id == 18 ? '2':'4'"></td>
                <td><h6 class=" text-right font-weight-bold">Total:</h6></td>
                <td class="text-right">{{ convertCurrency(dataDetails.total - paid) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-card
      outlined
      v-if=" paymentItems != null"
      class="mt-5"
    >
      <!-- <h3 class="font-weight-bold text-right ma-0">{{dataDetails.type == 'PEMASUKAN' ? 'Invoice' : 'Purchase Order'}}</h3> -->
      <h4 class="text-center font-weight-bold" style="margin: 10px 0px">{{dataDetails.type == 'PEMASUKAN' ? 'Riwayat Pembayaran' : 'Riwayat Pencairan' }}</h4>
      <v-simple-table fixed-header>
        <template>
          <thead class="grey lighten-4">
            <tr>
              <td style="background-color: lightgray!important;-webkit-print-color-adjust: exact" v-for="header in headerPaymentHistory" :key="header.text" :class="header.align">{{ header.text }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="subItem in paymentItems" :key="subItem.id">
              <!-- <td>{{ new Date(subItem.tanggal).toLocaleDateString('id') }}</td> -->
              <td>{{ formatdate(subItem.tanggal.replace(" 00:00:00", "")) }}</td>
              <td>{{ convertCurrency(Number(subItem.jumlah)) }}</td>
              <td class="text-right">{{ subItem.payment_method ? subItem.payment_method.name : '-' }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <v-row>
      <v-col cols="9">
        &nbsp;
      </v-col>
      <v-col cols="3" style="text-align-last: center">
        <p class="font-weight-bold mr-4" style="margin-top: 80px">Penerima,</p>
        <p class="font-weight-bold mr-4" style="margin-top: 100px">(.................................................)</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import isEmpty from "lodash/isEmpty";
import { formatCurrency } from "@/libs/number";
import moment from "moment";
export default {
  data: () => ({
    dialog2: false,
    dialog3: false,
    dialog: false,
    dialogNote: false,
    dialogApproval: false,
    dialogDetail: false,
    expand: false,
    note: '',
    approval: '',
    role: '',
    showError: false,
    dataUser: {},
    produk: [],
    // headers: [
    //   {
    //     text: "Nama",
    //     align: "left",
    //     value: "name"
    //   },
    //   { text: "Harga", value: "price" },
    //   { text: "Jumlah", value: "qty" },
    //   { text: "Total Harga", value: "total" },
    //   { text: "Total Harga", value: "total" },
    //   { text: "Total Harga", value: "total" },
    //   { text: "Tanggal", value: "date" },
    //   { text: "Status", value: "status" },
    //   { text: "Actions", value: "action", sortable: false }
    // ],
    item_pemasukan: [],
    dataDetails: { 
      "items": []
    },
    editedIndex: -1,
    editedItem: {
      // price: "",
      // qty: "",
      total: "",
      // date: "",
    },
    defaultItem: {
      // price: "",
      // qty: "",
      total: "",
      // date: "",
    },
    items: [{
      product_id: 0,
      item_name: "",
      harga_jual: "",
      harga_beli: "",
      qty: ""
    }],
    paymentItems: null,
    headerSubItem: [
      { text: "Nama Item", align: 'text-left'},
      { text: "Jumlah", align: 'text-center'},
      { text: "Harga", align: 'text-center'},
      { text: "Diskon", align: 'text-center'},
      { text: "PPN", align: 'text-center'},
      { text: "Total Harga", align: 'text-right'}
    ],
    headerPaymentHistory: [
      { text: "Tanggal"},
      { text: "Jumlah"},
      { text: "Wallet",  align: 'text-right'},
    ],
    paymentMethod: ["Bank Transfer", "Cash"],
    paid: 0,
    jumlahPayment: 0,
    paymentMethodSelected: "",
    paymentDate: "",
    urlLogo: null,
  }),

  computed: {
    computedHeaders () {
      let editedHeaders = this.headerSubItem
      if(this.dataDetails.company_id == 18) {
        editedHeaders = this.headerSubItem.filter(header => header.text !== "Diskon" && header.text !== "PPN");  
      }
      return editedHeaders;
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    formatdate(value){
      return moment(value).format("DD-MM-YYYY HH:mm:ss")
    },
    ...mapActions({
      getPemasukanByIdPOS: "pemasukan/getPemasukanByIdPOS",
      getTransaction: "transaction/getTransactionBySubmissionId",
      getUserById: "user/getUserById",
      getCompany: "company/getCompany",
    }),
    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },
    async initialize() {
      const response = await this.getPemasukanByIdPOS(this.$route.params.id)
      // console.log('response', response)
      if(isEmpty(response.data)){
        // console.log('error')
        this.$router.push('/error')
      }else{
        const responseUser = await this.getUserById(response.data[0].user_id)
        const responseCompany = await this.getCompany();
        forEach(responseCompany.data.attributes.company_attachment, attachment => {
          if(attachment.attachment_type == 'LOGO'){
            this.urlLogo = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + attachment.location + '/' + attachment.name
          }
        })
        this.dataUser = Object.assign({}, responseUser.data.attributes)
        this.dataDetails = Object.assign({}, response.data[0])
        const responsePayment = await this.getTransaction(this.$route.params.id)
        this.paymentItems = isEmpty(responsePayment.data.attributes) ? null : Object.assign({}, responsePayment.data.attributes)
        if(this.paymentItems != null){
          forEach(this.paymentItems, paymentItem => {
            this.paid += Number(paymentItem.jumlah)
          })
        }
      }

      setTimeout(function () {
        var content = window.document.querySelector('body').innerHTML

        if (content.length) {
          window.print()
          window.close()
        } else {
          initialize()
        }
      }, 200)
    }, 
  }
};
</script>
<style>
@media print {
  img{
    display: inline;
    visibility: visible;
  }
}
</style>